/**
 * Does the request footer render its compact (collapsed-tools) chrome?
 *
 * Native is always compact. Web collapses only at or below
 * `REQUEST_TOOLBAR_COMPACT_MAX_WIDTH` (640).
 *
 * Deliberately NARROWER than `useCompactRequestToolbar`, which also collapses
 * on `isSmallScreen` (< 1024). The footer row needs ~400pt of buttons; at 641px
 * it has ~593pt and fits comfortably, so collapsing a 900px browser window
 * would hide working controls to fix a phone bug — drift past what #1149 asked
 * for. The shared constant keeps the two from diverging if the number moves.
 */
import { Platform, useWindowDimensions } from 'react-native';

import { REQUEST_TOOLBAR_COMPACT_MAX_WIDTH } from '../components/RequestToolbar';

export function useCompactRequestFooter(): boolean {
  const { width } = useWindowDimensions();
  if (Platform.OS !== 'web') {
    return true;
  }
  return width <= REQUEST_TOOLBAR_COMPACT_MAX_WIDTH;
}
